import { cn } from "@/lib/utils"

interface SkeletonProps extends React.ComponentProps<"div"> {
  variant?: "default" | "shimmer" | "glow"
}

function Skeleton({ className, variant = "shimmer", ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "rounded-md",
        variant === "default" && "bg-accent animate-pulse",
        variant === "shimmer" && "skeleton-shimmer",
        variant === "glow" && "skeleton-glow",
        className
      )}
      {...props}
    />
  )
}

// Cosmic-themed skeleton shapes
function SkeletonCircle({ className, ...props }: React.ComponentProps<"div">) {
  return <Skeleton className={cn("rounded-full aspect-square", className)} {...props} />
}

function SkeletonText({ lines = 3, className, ...props }: React.ComponentProps<"div"> & { lines?: number }) {
  return (
    <div className={cn("space-y-3", className)} {...props}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton 
          key={i} 
          className={cn(
            "h-4",
            i === lines - 1 ? "w-3/4" : "w-full"
          )} 
        />
      ))}
    </div>
  )
}

function SkeletonCard({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("glass p-6 space-y-4 border-white/5", className)} {...props}>
      <Skeleton className="h-10 w-10 rounded-md" />
      <Skeleton className="h-4 w-2/3" />
      <SkeletonText lines={2} />
    </div>
  )
}

export { Skeleton, SkeletonCircle, SkeletonText, SkeletonCard }
